import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import KpiCard from "../../components/KpiCard/KpiCard";

export default function PageMobileModal({ app }) {
  return (
    <>
      <Grid
        container
        direction="column"
        justifyContent={"center"}
        alignItems={"center"}
        gap={"10px"}
        style={{
          width: "90%",
          margin: "auto",
          height: "100%",
          flexDirection: "row",
          paddingBottom: "62px",
        }}
      >
        <Grid
          item
          width={"48%"}
          style={{ paddingLeft: "0px", paddingTop: "0" }}
        >
          <KpiCard
            app={app}
            key={"Total Vanish"}
            KPITitle={"Total Vanish"}
            percentageId={"Tqzeyj"}
            valueId={"bcUtHJ"}
            goalValueId={"anuRUqn"}
            hasProgressBar={true}
            fullView
          ></KpiCard>
        </Grid>

        <Grid
          item
          width={"48%"}
          style={{ paddingLeft: "0px", paddingTop: "0" }}
        >
          <KpiCard
            app={app}
            key={"Harpic"}
            KPITitle={"Harpic"}
            percentageId={"bCbVu"}
            valueId={"PJEUEJ"}
            goalValueId={"ZxhyU"}
            hasProgressBar={true}
            fullView
          ></KpiCard>
        </Grid>

        <Grid
          item
          width={"48%"}
          style={{ paddingLeft: "0px", paddingTop: "0" }}
        >
          <KpiCard
            app={app}
            key={"Bom Ar"}
            KPITitle={"Bom Ar"}
            percentageId={"NZAgh"}
            valueId={"GmGTDqm"}
            goalValueId={"jaFMh"}
            hasProgressBar={true}
            fullView
          ></KpiCard>
        </Grid>

        <Grid
          item
          width={"48%"}
          style={{ paddingLeft: "0px", paddingTop: "0" }}
        >
          <KpiCard
            app={app}
            key={"SBP Aero 380ml"}
            KPITitle={"SBP Aero 380ml"}
            percentageId={"kJaSdK"}
            valueId={"jWPQqY"}
            goalValueId={"jPBTdSt"}
            hasProgressBar={true}
            fullView
          ></KpiCard>
        </Grid>

        <Grid
          item
          width={"48%"}
          style={{ paddingLeft: "0px", paddingTop: "0" }}
        >
          <KpiCard
            app={app}
            key={"LED"}
            KPITitle={"LED"}
            percentageId={"DkW"}
            valueId={"CLUVKX"}
            goalValueId={"mEzBU"}
            hasProgressBar={true}
            fullView
          ></KpiCard>
        </Grid>

        <Grid
          item
          width={"48%"}
          style={{ paddingLeft: "0px", paddingTop: "0" }}
        >
          <KpiCard
            app={app}
            key={"PIR"}
            KPITitle={"PIR"}
            percentageId={"zyehZjW"}
            valueId={"YVKZbS"}
            goalValueId={"GkjFtG"}
            hasProgressBar={true}
            fullView
          ></KpiCard>
        </Grid>

        <Grid
          item
          width={"48%"}
          style={{ paddingLeft: "0px", paddingTop: "0" }}
        >
          <KpiCard
            app={app}
            key={"Veja Cozinha"}
            KPITitle={"Veja Cozinha"}
            percentageId={"qYZg"}
            valueId={"gkjJUh"}
            goalValueId={"aCbfDE"}
            hasProgressBar={true}
            fullView
          ></KpiCard>
        </Grid>

        <Grid
          item
          width={"48%"}
          style={{ paddingLeft: "0px", paddingTop: "0" }}
        >
          <KpiCard
            app={app}
            key={"Veja Banheiro"}
            KPITitle={"Veja Banheiro"}
            percentageId={"HDmBUj"}
            valueId={"TVmAd"}
            goalValueId={"JSyrpMR"}
            hasProgressBar={true}
            fullView
          ></KpiCard>
        </Grid>

        <Grid
          item
          width={"48%"}
          style={{ paddingLeft: "0px", paddingTop: "0" }}
        >
          <KpiCard
            app={app}
            key={"Veja PF VMU"}
            KPITitle={"Veja PF VMU"}
            percentageId={"nzvbL"}
            valueId={"JmXvg"}
            goalValueId={"Vuykyq"}
            hasProgressBar={true}
            fullView
          ></KpiCard>
        </Grid>
      </Grid>
    </>
  );
}

PageMobileModal.defaultProps = {
  app: null,
  config: {},
};

PageMobileModal.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};
